<template>
  <div>
    <v-container class="pt-0">
      <span v-if="showHeader" class="headline">{{$t('coins.title')}}</span>
      <v-row>
        <v-col>
          <coin-balance/>
        </v-col>
      </v-row>
      <v-row v-if="payoutVisible">
        <v-col>
          <v-btn @click="function() {showPayoutDialog = true;}"><v-icon left>mdi-currency-eur</v-icon>{{$t('common.payout-coins')}}</v-btn>
        </v-col>
        <payout-dialog v-if="showPayoutDialog" :visible="showPayoutDialog" :closeAction="function() {showPayoutDialog = false}"/>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-btn link to="/shop">{{$t('coins.payout')}}</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn link to="/coins/transactions"><v-icon left>mdi-text-box-outline</v-icon>{{$t('coinTransactions.title')}}</v-btn>
        </v-col>
      </v-row>
      <coin-products/>
    </v-container>
  </div>
</template>

<script>
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import CoinBalance from "@/widgets/CoinBalance";
import CoinProducts from "@/widgets/CoinProducts";
import purchaseProduct from "@/mixins/purchaseProduct";
import { ACTION_LOAD_COIN_ACCOUNT } from "@/plugins/store";
import PayoutDialog from "@/widgets/payout/PayoutDialog";
import envMixin from "@/mixins/envMixin";

export default {
  name: "Coins",
  mixins: [purchaseProduct, envMixin],
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    CoinBalance,
    CoinProducts,
    PayoutDialog,
  },

  data: () =>
  ({
    loading: false,
    coinProducts: undefined,
    showPayoutDialog: false,
  }),
  computed: {
    payoutVisible() {
      return !this.$store.state.env.global.isCoinsPayoutDisabled
    }
  },
  mounted() {
    this.refresh();
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.refresh);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.refresh);
  },
  methods: {
    refresh: function () {
      this.$store.dispatch(ACTION_LOAD_COIN_ACCOUNT)
    },
  },
};
</script>
